<template>
<v-card>
  <TestInfo v-if="SettingsApp.displayTestInfo() && acl.isWorker()"/>
  <v-card-title>
    <v-spacer></v-spacer>
    <v-text-field v-model="search" append-icon="search" :label="`${$t('data-table.search')}`" single-line hide-details></v-text-field>
  </v-card-title>
  <v-data-table :headers="headers" :items="schemas" :loading="loading" :no-data-text="tableTranslations.noDataText" :rows-per-page-text="tableTranslations.rowsPerPageText"
                :search="search"
                class="elevation-1"
    :no-results-text="tableTranslations.noResultsText" :rows-per-page-items="pagination.rowsPerPageItems" :pagination.sync="pagination">
    <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
    <template slot="items" slot-scope="props">
      <td class="text-xs-center">{{ props.item.name }}
        <v-icon v-if="props.item.confirmation > 0" class="light-green--text">check_circle_outline</v-icon>
      </td>
      <td class="text-xs-center">
        <v-btn  color="teal darken-2" small round :to="{ name: 'form-fill', params: { schemaId: props.item.id } }">
          <v-icon class="schema-edit-icon">add</v-icon>
        </v-btn>
        <v-btn  color="teal darken-2" small round :to="{ name: 'form-view', params: { schemaId: props.item.id } }">
          {{$t('test.results')}}
        </v-btn>
      </td>
    </template>
  </v-data-table>
</v-card>
</template>

<script>
import i18n from '@/plugins/vuei18n'
import http from '@/plugins/http'
import TeamPicker from './list/TeamPicker'
import ExportMenu from './list/ExportMenu'
import Settings from './Settings'
import SettingsApp from '@/plugins/Settings'
import TestInfo from '@/components/form/TestInfo'
import Acl from "@/plugins/Acl";
import TestHelper from "@/plugins/TestHelper";


export default {
  components: {
    TeamPicker,
    ExportMenu,
    Settings,
    TestInfo
  },
  data() {
    return {
      pagination: this.$store.getters.pagination,
      schemas: [],
      loading: false,
      search: "",
      SettingsApp,
      acl: new Acl(),
      TestHelper
    }
  },
  computed: {
    tableTranslations() {
      return this.$store.getters.tableTranslations
    },
    headers: () => [
      {
        text: i18n.t('Test'),
        value: "name",
        width: "50%",
        align: 'center'
      },
      {
        text: i18n.t('schema.list.fill'),
        sortable: false,
        align: 'center',
        width: '50%'
      }
    ],
  },
  created() {
    this.loadSchemas()
  },
  methods: {
    loadSchemas() {
      this.loading = true
      http.get('schemas')
        .then(response => {
          this.schemas = response.data.filter(schema => schema.type == 2)
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    }
  },
}
</script>

<style scoped>
.schema-list-switch {
  margin: 10px 0 -10px;
}
</style>
